// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const libraryIsLoaded = (name: string): boolean => Boolean((window as any)[name]);
